/* cspell:words qmutation */

import callGraphQLApi from '@helpers/callGraphQLApi';
import { MAKE_PURCHASE_FAILURE, MAKE_PURCHASE_SUCCESS } from '../actions';
import { MakePurchaseRequest, Thunk } from './interfaces';

export interface ServiceMakePurchaseResponse {
  temporalDataObject: {
    assets: {
      records: {
        type: string;
        signedUri: string;
      }[];
    };
  };
}
export const serviceMakePurchase: Thunk<MakePurchaseRequest, any> =
  ({ foo }: MakePurchaseRequest) =>
  async (dispatch, getState) => {
    const query = `
      qmutation {
        temporalDataObject: temporalDataObject(id: $id) {
          assets(type: "redaction-media-data", orderBy: createdDateTime, limit: 1) {
            records {
              type
              signedUri
            }
          }
        }
      }
    `;

    return await callGraphQLApi<ServiceMakePurchaseResponse>({
      actionTypes: ['NOOP', MAKE_PURCHASE_SUCCESS, MAKE_PURCHASE_FAILURE],
      query,
      variables: { id: foo },
      dispatch,
      getState,
      bailout: undefined,
    });
  };
